import React, { useEffect } from "react"
import { useCookies } from "react-cookie"
import { CookieWrapperProps } from "~/interfaces/CookieWrapperProps"

const CookieWrapper = ({ children, value, cookieName, setValue }: CookieWrapperProps) => {
  const [cookie, setCookie] = useCookies([cookieName])

  useEffect(() => {
    setCookie(cookieName, value)
  }, [value])

  useEffect(() => {
    !!cookie[cookieName] && setValue(cookie[cookieName])
  }, [])

  return <>{children}</>
}

export default CookieWrapper
